const PrivacyPage = () => {
    return <div>Privacy Page</div>;
};

export default PrivacyPage;
